<template>
    <div class="bg-white rounded shadow-sm py-3 my-2">
        <form @submit.prevent="recharge_wallet" id="recharge_wallet_form">
            <div class="d-flex align-items-center px-3">
                <div class="mr-auto d-flex align-items-center h5">
                    <i class="fas fa-wallet text-primary"></i>
                    <div class="mx-2">{{ $t("open_banking_wallet.title") }}</div>
                </div>
                <div>
                    <span>{{ $t("open_banking_wallet.inquiry_count_can_send") }}</span>&nbsp;
                    <span>{{ form_data.wallet_balance }}</span>
                </div>
            </div>
            <hr/>
            <div class="p-3">
                <div class="d-flex align-items-center">
                    <div class="form-group w-50 px-3">
                        <label for="recharge_price">{{ $t("open_banking_wallet.recharge_wallet") }}</label>
                        <input
                                type="number"
                                id="recharge_price"
                                class="form-control"
                                v-model="recharge_price"
                                placeholder="مقدار افزایش"
                        />
                        <small class="form-text text-muted"
                        >{{ $t("notification.label.minimum_price_for_recharge") }}</small
                        >
                    </div>
                    <div class="form-group w-50 px-3">
                        <button
                                type="submit"
                                class="btn btn-success"
                                id="submit_btn_recharge_wallet">
                            <span>{{ $t("notification.label.pay") }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

export default {
    name: "rechargeWallet",
    props: {
        recharge_wallet: {
            default: () => {
            },
            type: Function,
        },
        form_data: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    data() {
        return {
            recharge_price: 0,
        };
    },
    methods: {

    },
};
</script>
<style scoped>

</style>